import { render } from "./PointInfoComponent.vue?vue&type=template&id=fc3c47f8&scoped=true"
import script from "./PointInfoComponent.vue?vue&type=script&lang=js"
export * from "./PointInfoComponent.vue?vue&type=script&lang=js"

import "./PointInfoComponent.vue?vue&type=style&index=0&id=fc3c47f8&scoped=true&lang=css"
import "./PointInfoComponent.vue?vue&type=style&index=1&id=fc3c47f8&lang=css"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc3c47f8"]])

export default __exports__